import { create } from 'zustand'

export type DownloadPhase = 'checking' | 'downloading' | 'paused' | 'extracting' | 'ready' | 'error' | 'cancelled'
export interface DownloadJob {
  id: string
  title: string
  phase: DownloadPhase
  percent: number
  loadedBytes?: number
  totalBytes?: number
  message?: string
  relativePath?: string
  open?: () => void
  retry?: () => void
}
interface DownloadState {
  jobs: DownloadJob[]
  collapsed: boolean
  toggle: () => void
  update: (id: string, patch: Partial<DownloadJob>) => void
  begin: (job: DownloadJob) => void
  remove: (id: string) => void
}
export const useDownloadStore = create<DownloadState>((set) => ({
  jobs: [], collapsed: false,
  toggle: () => set(s => ({ collapsed: !s.collapsed })),
  update: (id, patch) => set(s => ({ jobs: s.jobs.map(j => j.id === id ? { ...j, ...patch } : j) })),
  begin: job => set(s => ({ collapsed: false, jobs: s.jobs.some(j => j.id === job.id) ? s.jobs.map(j => j.id === job.id ? { ...j, ...job } : j) : [...s.jobs, job] })),
  remove: id => set(s => ({ jobs: s.jobs.filter(j => j.id !== id) })),
}))
